// extracted by mini-css-extract-plugin
module.exports = {"header":"page-header_header__19X89","logotype":"page-header_logotype__ge2aC"};